/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";
export const GET_UTILITY_CENTER_DETAIL = gql`
  query GetDistCent($filter: UniqDistCentFilterInput!) {
    getDistCent(filter: $filter) {
      address
      band {
        id
        label
        logo
        name
      }
      id
      name
      distCenterId
      geoLocation {
        coordinates
        type
      }
      counters {
        counterType
        id
        counterNo
        name
        createdAt
        distCent {
          name
          id
          band {
            name
            id
          }
        }
      }
    }
  }
`;
